// extracted by mini-css-extract-plugin
export default {"buttonPlus":"buttonPlus_buttonPlus__yDr4S"};